import { Component, HostListener, Input, OnInit } from '@angular/core';

import { LanguageService } from '../../../services/language.service';
import { LandingPageComponent } from '../../../core-page/landing-page/landing-page.component';
import { RouterUrls } from '../../router-urls';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-brand-header',
  templateUrl: './brand-header.component.html',
  styleUrls: ['./brand-header.component.scss'],
  providers: [LandingPageComponent],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ opacity: 0, transform: 'translateY(-10px)' }),
            animate('0.2s ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ opacity: 1, transform: 'translateY(0px)' }),
            animate('0.2s ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
          ]
        )
      ]
    )
  ]
})
export class BrandHeaderComponent implements OnInit {

  @Input() brandColor: string;
  @Input() brandLogoUrl: string;
  @Input() brandSlug: string;
  isLanguageListOpened = false;
  RouterUrls = RouterUrls;

  constructor(private languageService: LanguageService) {
  }

  get currentLang() {
    return this.languageService.getCurrentLangWithSlash();
  }

  @HostListener('document:mousedown', ['$event'])
  handleOutsideClick(event) {
    if (this.isLanguageListOpened
      && !event.target.classList.contains('language-element')
      && !event.target.classList.contains('language')
      && !event.target.classList.contains('language-icon')
      && !event.target.classList.contains('language-dropdown-arrow')) {
      this.isLanguageListOpened = false;
    }
  }

  ngOnInit(): void {
  }

  openCloseLanguageList() {
    this.isLanguageListOpened = !this.isLanguageListOpened;
  }

  changeLanguage(lang) {
    this.languageService.changeLanguage(lang);
  }
}
